import { LegalLayout, LegalBlock } from "../components/LegalLayout";
import { EMAIL, PHONE } from "../data";

export default function LegalNotice() {
  return (
    <LegalLayout title="Aviso legal" updated="junio de 2026">
      <LegalBlock heading="1. Datos identificativos">
        <p>
          En cumplimiento de la Ley 34/2002 de Servicios de la Sociedad de la Información y
          de Comercio Electrónico (LSSI-CE), se informa de los siguientes datos:
        </p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Titular: <strong>Iván Hondal López</strong> (Ventanas Hondal).</li>
          <li>Actividad: montaje y reparación de cerramientos de PVC y aluminio.</li>
          <li>Domicilio: Renedo de Piélagos (Cantabria), España.</li>
          <li>Teléfono: {PHONE}.</li>
          <li>Correo electrónico: {EMAIL}.</li>
        </ul>
      </LegalBlock>

      <LegalBlock heading="2. Objeto">
        <p>
          El presente sitio web tiene como finalidad ofrecer información sobre los servicios
          de carpintería de PVC y aluminio prestados por Iván Hondal López, así como permitir
          a los usuarios ponerse en contacto y solicitar presupuesto o cita.
        </p>
      </LegalBlock>

      <LegalBlock heading="3. Condiciones de uso">
        <p>
          El usuario se compromete a hacer un uso adecuado de los contenidos del sitio y a no
          emplearlos para actividades ilícitas o contrarias a la buena fe. El titular no se
          hace responsable del mal uso que se realice de los contenidos de la web.
        </p>
      </LegalBlock>

      <LegalBlock heading="4. Propiedad intelectual e industrial">
        <p>
          Los contenidos, textos, fotografías de trabajos, logotipo y diseño de este sitio son
          titularidad de Iván Hondal López o cuentan con la autorización correspondiente. Queda
          prohibida su reproducción total o parcial sin autorización expresa.
        </p>
      </LegalBlock>

      <LegalBlock heading="5. Legislación aplicable">
        <p>
          Las presentes condiciones se rigen por la legislación española. Para cualquier
          controversia serán competentes los juzgados y tribunales que correspondan conforme
          a derecho.
        </p>
      </LegalBlock>
    </LegalLayout>
  );
}
